import React, { Component } from 'react';
import { Select, Card, Row, Popover } from 'antd';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { SelectCol } from '../styled';
import IconSvg from '../../../common/IconSvg';

const { Option } = Select;
const iconMargin = '10px';

@injectIntl
@observer
export class PolicyItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHover: false,
    };
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter() {
    this.setState({ isHover: true });
  }

  handleMouseLeave() {
    this.setState({ isHover: false });
  }

  render() {
    const {
      policyType,
      policyKeyName,
      intl,
      styles,
      selectedValues,
      policy,
      openEditForm,
    } = this.props;

    return (
      <Card style={{ ...styles }}>
        <Row
          style={{ display: 'flex' }}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onFocus={this.handleMouseEnter}
          onMouseOver={this.handleMouseEnter}
        >
          <SelectCol width="50%">
            <h2 style={{ marginLeft: '5px', marginBottom: '5px' }}>
              {intl.formatMessage({ id: `listing.${policyKeyName}` })}
            </h2>
            <Select
              value={selectedValues ? selectedValues.name : ''}
              style={{ marginBottom: '20px' }}
              onSelect={(value, e) => policy.setPolicy(e, policyKeyName)}
            >
              {policyType.map(({ code, name, details }) => (
                <Option key={code} value={name}>
                  {details ? (
                    <Popover
                      placement="left"
                      key={code}
                      content={details}
                      title="Details"
                      style={{ zIndex: 100, marginTop: '-50px' }}
                    >
                      {name}
                    </Popover>
                  ) : (
                    name
                  )}
                </Option>
              ))}
            </Select>
          </SelectCol>
          {this.state.isHover ? (
            <SelectCol width="50%" justifyContent="center" alignItems="flex-start">
              <div>
                <IconSvg
                  type="plus-circle"
                  marginRight={iconMargin}
                  onClick={() => openEditForm({ policyType: policyKeyName })}
                  size={20}
                />
                <IconSvg
                  type="edit"
                  marginRight={iconMargin}
                  onClick={() => {
                    if (selectedValues && selectedValues.name) {
                      openEditForm({ policyType: policyKeyName, isCreateAction: false });
                    }
                  }}
                  size={20}
                />
              </div>
            </SelectCol>
          ) : null}
        </Row>
      </Card>
    );
  }
}

PolicyItem.propTypes = {
  policyType: PropTypes.arrayOf(PropTypes.shape),
  policyKeyName: PropTypes.string,
  intl: PropTypes.objectOf(PropTypes.shape),
  styles: PropTypes.objectOf(PropTypes.string),
  selectedValues: PropTypes.objectOf(PropTypes.shape),
  policy: PropTypes.objectOf(PropTypes.shape),
  openEditForm: PropTypes.func,
};
